import _ from 'underscore';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';

export const WIZARD_MODE = {
  SMART: 'SMART',
  UNIFIED_SMART: 'UNIFIED_SMART',
  EXPERT: 'EXPERT',
  SMART_GOOGLE_IMPORT: 'SMART_GOOGLE_IMPORT',
  FACEBOOK_IMPORT: 'FACEBOOK_IMPORT',
  NONE: null,
};

export const SharedWizardContext = React.createContext([
  {
    website: undefined,
    isSwitchFromSmartMidSignup: false,
    wizardMode: WIZARD_MODE.SMART,
  },
  _.noop,
]);

export function SharedWizardContextProvider(props) {
  const { children } = props;
  const [sharedWizardContext, setSharedWizardContext] = useState({
    wizardMode: WIZARD_MODE.NONE,
  });
  const updateSharedWizardContext = useCallback((delta) => {
    setSharedWizardContext({
      ...sharedWizardContext,
      ...delta,
    });
  }, [sharedWizardContext]);

  return (
    <SharedWizardContext.Provider value={[
      sharedWizardContext,
      updateSharedWizardContext,
    ]}
    >
      {children}
    </SharedWizardContext.Provider>
  );
}

SharedWizardContextProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
};
